module.exports = "<div class=\"global-settings-master col-md-12 paper-sheet clearfix\">\n  <div class=\"detail-container\">\n    <div class=\"title\">\n      <h5>Global Settings</h5>\n    </div>\n    <div class=\"col-md-2\"><app-router-tabs [activeForChildren]=\"true\" [routeInfo]=\"links\"></app-router-tabs></div>\n  </div>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/global-settings.component.html
// module id = ../../../../../src/app/global-settings/global-settings.component.html
// module chunks = 2